import { routes } from '../consts/routes';

// eslint-disable-next-line no-undef
export type TPath = Values<typeof routes>;
export const getRoute = (path: TPath) => `/${path}`;
